;
define("newsletter.tpl", function(){});

